export default __webpack_public_path__ + "static/media/lever-gris.dbc2f0bf.jpg";